/**
 * @generated SignedSource<<63bd6025417eb665b2f04637067a7878>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EpisodeList_episode$data = {
  readonly audioS3Key: string;
  readonly chapters: ReadonlyArray<{
    readonly endTimeMs: number;
    readonly id: string;
    readonly startTimeMs: number;
    readonly title: string;
  }>;
  readonly durationSeconds: number;
  readonly episodeId: string;
  readonly id: string;
  readonly isLikedByViewer: boolean | null | undefined;
  readonly likeCount: number;
  readonly publishedAt: any;
  readonly sourceLinks: ReadonlyArray<string>;
  readonly summary: string;
  readonly title: string;
  readonly topicSlug: string;
  readonly transcript: string;
  readonly " $fragmentType": "EpisodeList_episode";
};
export type EpisodeList_episode$key = {
  readonly " $data"?: EpisodeList_episode$data;
  readonly " $fragmentSpreads": FragmentRefs<"EpisodeList_episode">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "EpisodeList_episode"
};

(node as any).hash = "14b00fa7b23ae99307647a8ff4dad34c";

export default node;
